import "./style/BarLoading.css";
const BarLoading = () => {
  return (
    <div className="loader-container">
      <div className="lds-facebook">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default BarLoading;
